import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filenameOnly',
})
export class FilenameOnlyPipe implements PipeTransform {
  // eslint-disable-next-line class-methods-use-this
  transform(url: string): string {
    if (!url) return '';
    return url.split('/').pop() || '';
  }
}
